<div class="persistent-simple-text-section-title">
  <app-simple-text-section #textSectionComponent *ngIf="loaded" [(text)]="text" [readOnly]="true"
    [editAvailable]="editAvailable" [editToggleAvailable]="editToggleAvailable" [actions]="actions"
    [textTransformer]="textTransformer">
  </app-simple-text-section>
</div>